<template>
  <app-view @open="onOpen">
    <div class="container">
      <div class="line">
        <span>相关视频:</span>
        <span class="video">{{item.title}}</span>
      </div>
      <div class="line">
        <span>标题:</span>
        <input v-model="item.subtitle" placeholder="请输入标题">
      </div>
      <div>
        <textarea v-model="item.content" placeholder="请输入内容"></textarea>
      </div>
    </div>
    <div class="submit">
      <a href="javascript:;" @click="onSubmit">保 存</a>
    </div>
  </app-view>
</template>
<script>
import AppView from '../components/AppView.vue'

export default {
  components: { AppView },
  data() {
    return {
      item: {}
    }
  },
  computed: {
    movid() {
      return this.$route.params.movid
    },
    urlid() {
      return this.$route.params.urlid
    }
  },
  methods: {
    async onOpen() {
      try {
        this.item = await this.$service.user.getNote(this.movid, this.urlid)
      } catch (e) {
        this.item = {
          title: this.$route.query.m || '',
          subtitle: this.$route.query.t || '',
          content: ''
        }
      }
    },
    async onSubmit() {
      if (!this.item.subtitle) {
        this.$toast('请填写标题')
        return
      }
      if (!this.item.content) {
        this.$toast('请填写内容')
        return
      }
      if (this.item.id) {
        await this.$service.user.updateNode(this.item.id, this.item.title, this.item.subtitle, this.item.content)
      } else {
        await this.$service.user.addNote(this.movid, this.urlid, this.item.title, this.item.subtitle, this.item.content)
      }
      this.$toast('保存成功')
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped lang='scss'>
.container {
  background-color: $color-white;
  > div {
    display: flex;
    padding: 0 $app-padding;
    border-bottom: $style-border;
    > span {
      &:first-child {
        width: 100px;
      }
    }
  }
  .line {
    line-height: 44px;
  }
  .video {
    color: $color-red;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  input {
    flex: 1;
  }
  textarea {
    width: 100%;
    height: 200px;
    padding: $app-padding 0;
  }
}

.submit {
  padding: 2 * $app-padding $app-padding;
  a {
    display: block;
    background-color: $color-red;
    line-height: 44px;
    font-size: 18px;
    text-align: center;
    color: $color-white;
    border-radius: 4px;
    &:active {
      background-color: rgba($color-red, 0.7);
    }
  }
}
</style>



// WEBPACK FOOTER //
// editor.vue?34e78da4